<div class="map-toolbar"
    [class.can-toggle]="canToggle">
    <!-- MAIN ICONS -->
    <div class="map-toolbar__icons">
        <ng-container *ngIf="controlsIndex.zoom">
            <kui-icon name="minus"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="zoomOut.emit()"
                [size]="1"
                [title]="'LEAFLET.ZOOM.OUT' | translate"></kui-icon>
            <kui-icon name="plus"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="zoomIn.emit()"
                [size]="1"
                [title]="'LEAFLET.ZOOM.IN' | translate"></kui-icon>
        </ng-container>
        <kui-icon *ngIf="controlsIndex.recenter"
            name="crosshairs"
            kui-action
            (click)="reset.emit()"
            class="map-toolbar__icons__icon"
            [size]="1"
            [title]="'LEAFLET.ZOOM.RESET' | translate"></kui-icon>
        <kui-icon *ngIf="controlsIndex.fullscreen"
            [name]="isFullscreen ? 'compress' : 'expand'"
            kui-action
            class="map-toolbar__icons__icon"
            (click)="fullscreen.emit()"
            [size]="1"
            [title]="(isFullscreen ? 'LEAFLET.FULLSCREEN.EXIT' : 'LEAFLET.FULLSCREEN.ENTER') | translate"></kui-icon>
    </div>
    <ng-container *ngIf="expanded">
        <!-- COLLAPSABLE ICONS -->
        <div class="map-toolbar__icons">
            <kui-icon *ngIf="controlsIndex.layers"
                name="layer-group"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="toggleVisiblePanel('layers')"
                [title]="'LEAFLET.LAYERS' | translate"
                [size]="1"
                [class.text-primary]="show.layers"></kui-icon>
            <kui-icon *ngIf="controlsIndex.measurements"
                name="ruler-triangle"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="openMeasurements()"
                [title]="'LEAFLET.MEASUREMENTS.TOOLTIP' | translate"
                [size]="1"
                [class.text-primary]="show.measurements"></kui-icon>
            <kui-icon *ngIf="controlsIndex.coordinates"
                name="map-pin"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="openCoordinates()"
                [title]="'LEAFLET.COORDINATES.TITLE' | translate"
                [size]="1"
                [class.text-primary]="show.coordinates"></kui-icon>
            <kui-icon *ngIf="controlsIndex.zoneedit || controlsIndex.zoneadd || controlsIndex.zonedelete"
                name="layer-plus"
                kui-action
                class="map-toolbar__icons__icon"
                (click)="toggleVisiblePanel('zoneselect')"
                [title]="'LEAFLET.ZONES_AND_ROUTES' | translate"
                [size]="1"
                [class.text-primary]="show.zoneaddpolygon || show.zoneaddpolyline || show.zonedelete || show.zoneedit || show.zoneselect"></kui-icon>
        </div>
        <!-- only show search when we are not on street routing to avoid confusion of too many search fields -->
        <div *ngIf="controlsIndex.search && !show.routing"
            class="map-toolbar__searchbar">
            <kui-input-group [cleanAddons]="true">
                <input kui-input
                    #searchInput
                    type="text"
                    [placeholder]="'SHARED.SEARCH_ELLIPSES' | translate"
                    [ngModel]="searchValue"
                    (ngModelChange)="debouncedUpdateSearchValue($event)"
                    (focus)="!!searchValue && toggleVisiblePanel('search', true);">
                <kui-icon *ngIf="!searching && !searchValue"
                    kui-input-group-addon
                    name="search"
                    [size]="1"></kui-icon>
                <kui-icon *ngIf="controlsIndex.routing && lastSelectedSearchItem"
                    kui-input-group-addon
                    kui-action
                    class="pr-2"
                    color="primary"
                    name="directions"
                    [title]="'LEAFLET.ROUTING.GET_ROUTE' | translate"
                    (click)="openRouting({
                        searchTerm: searchValue,
                        address: lastSelectedSearchItem.name,
                        lat: lastSelectedSearchItem.lat,
                        lon: lastSelectedSearchItem.lon
                    })"></kui-icon>
                <kui-icon *ngIf="!searching && !!searchValue"
                    kui-input-group-addon
                    kui-action
                    name="times"
                    class="pl-2"
                    [title]="'DIALOG.CLEAR' | translate"
                    (click)="clearSearch()"
                    [size]="1"></kui-icon>
                <kui-loader *ngIf="searching"
                    kui-input-group-addon
                    size="small"></kui-loader>
            </kui-input-group>
        </div>
    </ng-container>
    <!-- TOGGLE -->
    <div class="map-toolbar__toggle"
        (click)="toggle(!expanded)">
        <kui-icon *ngIf="expanded"
            kui-action
            name="chevron-right"
            [title]="'LEAFLET.VIEW_LESS' | translate"
            [size]="1"></kui-icon>
        <kui-icon *ngIf="!expanded"
            kui-action
            name="bars"
            [title]="'LEAFLET.VIEW_MORE' | translate"
            [size]="1"></kui-icon>
    </div>
</div>
<div class="map-toolbar-cards"
    [ngClass]="{
        'routing': show.routing,
        'height-sm': mapHeight < 350,
        'height-md': mapHeight >= 350 && mapHeight <= 420,
        'height-lg': mapHeight > 420,
        'bypass-cards-overflow': bypassCardOverflow
    }">
    <kui-card *ngIf="show.layers">
        <kui-card-body>
            <div *ngFor="let layer of baseLayers; let l = last;"
                class="d-flex align-items-center"
                [class.mb-2]="!l">
                <input [id]="layer.title"
                    [checked]="layer.visible"
                    type="radio"
                    name="baseLayers"
                    class="mr-2"
                    (click)="clickLayer($event, layer)">
                <label [for]="layer.title"
                    class="mb-0">{{ layer.title }}</label>
            </div>
        </kui-card-body>
        <kui-card-body>
            <div *ngFor="let overlay of overlays; let l = last;"
                class="d-flex align-items-center"
                [class.mb-2]="!l">
                <input [id]="overlay.title"
                    [checked]="overlay.visible"
                    type="checkbox"
                    class="mr-2"
                    (click)="clickLayer($event, overlay)">
                <label [for]="overlay.title"
                    class="mb-0">{{ overlay.title }}</label>
            </div>
        </kui-card-body>
    </kui-card>
    <kui-card *ngIf="show.search">
        <kui-card-body [class.text-center]="searching">
            <kui-loader *ngIf="searching"
                size="small"></kui-loader>
            <div *ngIf="!searching && !searchResults?.length">{{'LEAFLET.NO_RESULTS' | translate}}</div>
            <key-search-results-list *ngIf="!searching && searchResults?.length"
                [list]="searchResults"
                [highlightValue]="searchValue"
                (onBlur)="blurSearchInput()"
                (onSelected)="hideSearchList()"></key-search-results-list>
        </kui-card-body>
    </kui-card>
    <kui-card *ngIf="show.zoneselect">
        <kui-card-body>
            <div *ngFor="let zoneTool of zonesDropdown; let l = last;"
                class="d-flex align-items-center"
                kui-action
                (click)="zoneTool.action()"
                [class.mb-3]="!l">
                <kui-icon [name]="zoneTool.icon"
                    class="mr-2"
                    [size]="1"></kui-icon>
                <span>{{ zoneTool.text }}</span>
            </div>
        </kui-card-body>
    </kui-card>
    <kui-card *ngIf="show.measurements">
        <kui-card-body>
            <h5>{{ 'LEAFLET.MEASUREMENTS.TITLE' | translate }}: {{ measurementDistance }}</h5>
            <p>{{ 'LEAFLET.MEASUREMENTS.DESC' | translate }}</p>
            <button kui-button
                color="primary"
                class="mr-1 mt-1"
                (click)="copyToClipboard(measurementDistance)">{{ 'DIALOG.COPY' | translate }}</button>
            <button kui-button
                color="secondary"
                class="mr-1 mt-1"
                (click)="measurementsUndo.emit()">{{ 'LEAFLET.DRAW.DELETE_LAST_POINT' | translate }}</button>
            <button kui-button
                color="secondary"
                class="mr-1 mt-1"
                (click)="closeMeasurements()">{{ 'DIALOG.CLOSE' | translate }}</button>
        </kui-card-body>
    </kui-card>
    <kui-card *ngIf="show.coordinates && ((media.isDesktop | async) || !!coordinatesDetails)">
        <kui-card-body>
            <h5>{{ 'LEAFLET.COORDINATES.TITLE' | translate }}</h5>
            <p *ngIf="coordinatesError; else noError">{{coordinatesError}}</p>
            <ng-template #noError>
                <div *ngIf="loadingCoordinates"
                    class="p-3">
                    <kui-loader size="small"></kui-loader>
                </div>
                <p *ngIf="!loadingCoordinates && !coordinatesDetails">{{ 'LEAFLET.COORDINATES.DESC' | translate }}</p>
                <div class="list mb-3"
                    *ngIf="!loadingCoordinates && coordinatesDetails">
                    <p *ngIf="!coordinatesDetails.length">{{ 'LEAFLET.COORDINATES.NO_ITEMS' | translate }}</p>
                    <ng-container *ngIf="!!coordinatesDetails.length">
                        <div class="flex-1">
                            <table>
                                <tr *ngFor="let coord of coordinatesDetails">
                                    <td>{{ coord.title }}</td>
                                    <td>{{ coord.text }}</td>
                                </tr>
                            </table>
                        </div>
                        <kui-icon *ngIf="controlsIndex.routing"
                            kui-action
                            class="px-4"
                            size="xxl"
                            color="primary"
                            name="directions"
                            [title]="'LEAFLET.ROUTING.GET_ROUTE' | translate"
                            (click)="openRouting({
                                address: coordinates.address,
                                lat: coordinates.lat,
                                lon: coordinates.lon
                            })"></kui-icon>
                    </ng-container>
                </div>
            </ng-template>
            <button kui-button
                *ngIf="controlsIndex.googlemaps && !loadingCoordinates && !!coordinatesDetails?.length"
                class="mr-1 mt-1"
                (click)="openGoogleMaps.emit(coordinates)">
                <svg class="mr-2 map-toolbar-cards__button-svg"
                    viewBox="0 0 19 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.67118 11.7785L16.5175 19.6249H0.824812L8.67118 11.7785ZM17.3423 8.93225V18.8L9.49607 10.9537L11.0637 9.38603C11.0339 9.34964 11.0039 9.31316 10.9739 9.27645C10.7614 9.01756 10.5424 8.75035 10.3315 8.46852L0 18.8V2.67135C0 2.45663 0.174124 2.2825 0.388842 2.2825H9.83374C10.722 0.910513 12.2651 0 14.0177 0C16.7649 0 19 2.23507 19 4.98224C19.0001 6.7171 18.1697 7.90594 17.3423 8.93225ZM7.64923 6.25577H4.76728V7.35363H6.46497C6.23291 8.06964 5.55959 8.58883 4.76728 8.58883C3.78351 8.58883 2.9832 7.78851 2.9832 6.80474C2.9832 5.82097 3.78359 5.02065 4.76728 5.02065C5.16468 5.02065 5.54054 5.14835 5.85433 5.3899L6.52407 4.51998C6.01663 4.12927 5.40911 3.9228 4.76728 3.9228C3.17816 3.9228 1.88526 5.2157 1.88526 6.80482C1.88526 8.39394 3.17809 9.68684 4.76728 9.68684C6.3564 9.68684 7.6493 8.39394 7.6493 6.80482V6.25577H7.64923ZM17.8335 4.98224C17.8335 2.87487 16.1252 1.16653 14.0178 1.16653C11.9104 1.16653 10.2021 2.87494 10.2021 4.98224C10.2021 8.15006 13.7842 9.05777 13.7842 12.8318H14.0178H14.2515C14.2513 9.05785 17.8335 8.15014 17.8335 4.98224ZM14.0177 3.23711C13.1965 3.23711 12.5308 3.90281 12.5308 4.72397C12.5308 5.5452 13.1966 6.2109 14.0177 6.2109C14.839 6.2109 15.5047 5.54512 15.5047 4.72397C15.5047 3.90281 14.839 3.23711 14.0177 3.23711Z" />
                </svg>
                <span>{{ 'LEAFLET.GOOGLE_MAPS' | translate }}</span>
            </button>
            <button kui-button
                *ngIf="coordinates"
                color="secondary"
                class="mr-1 mt-1"
                (click)="openCoordinates(true)">{{ 'LEAFLET.COORDINATES.NEW_PIN' | translate }}</button>
            <button kui-button
                color="secondary"
                class="mr-1 mt-1"
                (click)="closeCoordinates()">{{ 'DIALOG.CLOSE' | translate }}</button>
        </kui-card-body>
    </kui-card>
    <key-map-toolbar-zones [items]="zonesPanels"
        [show]="{
            zoneaddpolyline: show.zoneaddpolyline,
            zoneaddpolygon: show.zoneaddpolygon,
            zoneedit: show.zoneedit,
            zonedelete: show.zonedelete
        }"></key-map-toolbar-zones>
    <key-map-toolbar-routing *ngIf="show.routing"
        class="flex-1 d-flex"
        [inputs]="routeInputs"
        (onSetMarker)="markerAdd.emit($event)"
        (onMarkersClear)="clearMultipleMarkers($event)"
        (onRoutesUpdated)="updateRoutes($event)"
        (onRoutesClear)="clearRoutes($event)"
        (onClose)="toggleVisiblePanel(null)"></key-map-toolbar-routing>
</div>